import RequestHandler from "./RequestHandler";

function LotsAPI() {
    const baseLotAPI = "lots";

    async function getLots(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "materialName";
            const sortDirection = defaultSortDirection || "ASC";
            let URL = `${baseLotAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getLot(locationId) {
        try {
            const result = await RequestHandler.get(
                `${baseLotAPI}/${locationId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteLot(locationId) {
        try {
            const result = await RequestHandler.remove(
                `${baseLotAPI}/${locationId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function createLot(location) {
        try {
            const result = await RequestHandler.post(baseLotAPI, location);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateLot(location) {
        try {
            const result = await RequestHandler.put(baseLotAPI, location);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getLots,
        getLot,
        deleteLot,
        createLot,
        updateLot,
    };
}

export default LotsAPI();
